import { render, staticRenderFns } from "./COVIDForm.vue?vue&type=template&id=2ab57618&scoped=true&"
import script from "./COVIDForm.vue?vue&type=script&lang=js&"
export * from "./COVIDForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab57618",
  null
  
)

export default component.exports